/**
 * [polecenie właściciela 2026-09-19] „POPRAW UI dla sekcji Utwórz nowe zgłoszenie w kategorii
 * Wykup sprzętu”.
 *
 * ── CO BYŁO ŹLE (zmierzone na zrzucie właściciela i w kodzie okna) ──────────────────────────
 * Formularz wykupu kończył się na rzędzie ikon typu sprzętu. Pod nim stało zielone pudło
 * „Twoje zgłoszenie trafi do działu…”, a DALEJ nie było nic — cała reszta okna była pusta.
 * Człowiek nie widział, ile jeszcze przed nim: czy wybór ikony to koniec, czy początek.
 * Kroki istniały w kodzie (typ → urządzenie → uzasadnienie), ale wyłącznie jako kolejność
 * warunków `{buyoutData.type && …}` — czyli NIGDZIE na ekranie.
 *
 * ── DLACZEGO OSOBNY MODUŁ ────────────────────────────────────────────────────────────────────
 * „Na którym kroku jestem” to reguła, nie wygląd: zależy od tego, czy pracownik ma w ewidencji
 * sprzęt tego typu (wtedy krok 2 to WYBÓR z listy), czy nie ma (wtedy krok 2 to WPISANIE numeru
 * seryjnego). Zaszyta w renderze okna na 2600 linii daje się zmierzyć wyłącznie przez zmontowanie
 * całego modala z kompletem atrap.
 */

/** Kroki wykupu — numer, tytuł i zdanie mówiące, co się na nim dzieje. */
export const KROKI_WYKUPU = [
    { nr: 1, tytul: "Typ sprzętu", opis: "Wybierz, czego dotyczy wykup." },
    { nr: 2, tytul: "Urządzenie", opis: "Wskaż sprzęt z ewidencji albo podaj numer seryjny." },
    { nr: 3, tytul: "Uzasadnienie", opis: "Napisz, dlaczego chcesz wykupić ten sprzęt." },
];

/**
 * Numer kroku, na którym stoi formularz wykupu.
 *
 * 🔴 KROK 2 MA DWIE POSTACIE I OBIE MUSZĄ GO ZAMYKAĆ. Gdy pracownik ma w ewidencji sprzęt tego
 * typu, krok 2 zamyka WYBÓR urządzenia. Gdy nie ma ani jednego — ewidencja nie ma czego pokazać,
 * więc krok 2 zamyka WPISANY numer seryjny. Reguła licząca wyłącznie `wybraneUrzadzenie`
 * trzymałaby takiego człowieka na kroku 2 na zawsze: wypełniłby cały formularz i do końca widział
 * podświetlony krok, którego nie da się u niego wykonać.
 *
 * @param {object}  stan
 * @param {string}  stan.typ                wybrany typ sprzętu ("" = nie wybrano)
 * @param {number}  stan.liczbaUrzadzen     ile urządzeń tego typu ma pracownik w ewidencji
 * @param {object}  stan.wybraneUrzadzenie  urządzenie wskazane z listy (null = żadne)
 * @param {string}  stan.numerRecznie       numer seryjny wpisany ręcznie
 * @returns {1|2|3}
 */
export const krokWykupu = ({ typ, liczbaUrzadzen = 0, wybraneUrzadzenie = null, numerRecznie = "" } = {}) => {
    if (!String(typ || "").trim()) return 1;

    const krokUrzadzeniaZamkniety = liczbaUrzadzen > 0
        ? Boolean(wybraneUrzadzenie)
        : Boolean(String(numerRecznie || "").trim());

    return krokUrzadzeniaZamkniety ? 3 : 2;
};
